import { Helmet } from 'react-helmet';
import Lines from '../../components/common/Lines';
import ProgressScroll from '../../components/common/ProgressScroll';
import Cursor from '../../components/common/cusor';
import Footer from '../../components/home-main/Footer';
import Header from '../../components/home-main/Header';
import Intro from '../../components/home-main/Intro';
import Marquee from '../../components/home-main/Marquee';
import Team from '../../components/home-main/Team';
import Brands from '../../components/home-main/Brands';
import Navbar from '../../components/home-main/Navbar';
import Investors from '../../components/home-main/Investors';
import MarketValue from '../../components/home-main/MarketValue';
import DallService from '../../components/home-main/DallService';
// import DigitalProducts from '../../components/home-main/DigitalProducts';
import Events from '../../components/home-main/SocialMediaPresent';
import Services from '@/components/home-main/Services';
import IntroSub from '@/components/home-main/IntroSub';
import DigitalProducts from '@/components/home-main/DigitalProducts';

export default function LHomeMain() {
  

  return (
    <>
      <Helmet>
        <title>GCAD - tech business lap</title>

        <link rel="icon" href="/light/assets/imgs/fox.webp" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
 
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      
      <div>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar />
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <main className="main-bg o-hidden">
              <Header />
              <div className="padded-container">
                <Marquee />
                <Intro />
                <DallService />
                <IntroSub />
                <Services />
                <DigitalProducts />
                <MarketValue />
                <Marquee />
                <Events/>
                <Investors />
                <Team />
                <Brands />
              </div>
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
